export default __webpack_public_path__ + "static/media/ic_channel_1.64b9aa2b.svg";